import { useCallback } from 'react'
import type { JSX } from 'react'

import { DropdownMenu, LinkIcon } from '@buffer-mono/popcorn'

import { usePostPermalinksEnabled } from '~publish/hooks/usePostPermalinksEnabled'

import { copyDraftPermalinkToClipboard } from './copyDraftPermalink'

/**
 * Reads the flag itself so the element stays in the menu whatever the treatment.
 * MoreActionsDropdown invokes function children to decide whether it has anything
 * to show, so a child that comes and goes changes the invoker's hook count.
 */
export const CopyDraftLinkMenuItem = ({
  contentItemId,
}: {
  contentItemId: string
}): JSX.Element | null => {
  const permalinksEnabled = usePostPermalinksEnabled()

  const handleCopyDraftLink = useCallback(async () => {
    await copyDraftPermalinkToClipboard(contentItemId)
  }, [contentItemId])

  if (!permalinksEnabled) {
    return null
  }

  return (
    <DropdownMenu.Item onSelect={handleCopyDraftLink}>
      <LinkIcon />
      Copy Link
    </DropdownMenu.Item>
  )
}
